import Alpine from 'alpinejs'

import tooltip from './plugin.tooltip.js'
Alpine.plugin(tooltip)
